import React, {useEffect, useState} from 'react';
import arrow from "../../../../images/down.svg";
import check from "../../../../images/white-check.svg";
import {Field} from "formik";
import {yachtsModels} from "../../../../redux/types";
import plus from "../../../../images/blue-plus.svg";
import arrowDown from "../../../../images/input-arrow.svg";
import infoIcon from "../../../../images/info-circle.svg";
import ReactTooltip from "react-tooltip";
import {CustomCheckBox} from "../../../main/logbook/EditTable";
import {connect} from "react-redux";
import {getCommonData} from "../../../../redux/data/data-thunks";
import {OPERATORS, YACHT_MODELS, YACHTS} from "../../../../redux/data/data-types";
import {useTranslation} from "react-i18next";
import {getFavoriteYachts} from "../../../../redux/profile/profile-thunks";

const YachtInfoBlock = ({
                          setFieldValue, handleChange, model, openCreateModel, yacht, year, isPrivateOwn,
                          operator, owner, isDark, isAddFavorite, errors, submitCount, isEdit,
                          selectedYacht, setSelectedYacht, yachtInfoRef, ...props
                        }) => {
  useEffect(() => {
    if (props.profile) {
      props.getFavoriteYachts()
    }
  }, [])
  errors = submitCount > 0 ? errors : {}
  const {t} = useTranslation()
  useEffect(() => {
    if (!isEdit) {
      props.getCommonData(YACHT_MODELS)
      props.getCommonData(OPERATORS)
    }
  }, [])
  useEffect(() => {
    if(errors.model || errors.yacht || errors.operator) {
      yachtInfoRef.current.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }, [errors.model, errors.yacht, errors.operator])
  let isDisabled = props.favoriteYachts?.find(f => f.yacht_id === selectedYacht?.id)
  return (
    <div className="modal__section" ref={yachtInfoRef}>
      <input defaultChecked={true} id={'check2'} checked={errors.model || errors.yacht || errors.operator}
             type="checkbox" className={'modal__check'}/>
      <label htmlFor={'check2'} className="modal__subTitle">
        <h6 className="modal__underTitle">{t('infoYacht')}</h6>
        <div className="modal__collapse">
          <img src={arrow} alt=""/>
        </div>
      </label>
      <div className="modal__inputs">
        <div className="modal__yachts">
          {props.favoriteYachts?.map((item, index) => <button onClick={() => {
            if (item.yacht_id === selectedYacht?.id) {
              setSelectedYacht(null)
            } else {
              setSelectedYacht(item.yacht)
              setFieldValue('model', item.yacht.yacht_model.name)
              props.getCommonData(YACHT_MODELS, item.yacht.yacht_model.name)
              setFieldValue('yacht', item.yacht.name)
              setFieldValue('year', item.yacht.year ?? '')
              setFieldValue('isPrivateOwn', !!item.yacht.yacht_owner_name)
              setFieldValue('operator', item.yacht.operator?.name ?? '')
              if (item.yacht.operator) {
                props.getCommonData(OPERATORS, item.yacht.operator.name)
              }
              setFieldValue('owner', item.yacht.yacht_owner_name ?? '')
            }
          }}
                                                              className={`modal__yacht ${selectedYacht?.id === item.yacht_id && 'modal__yachtSelected'}`}
                                                              key={index}>
            {item.yacht.name} {item.yacht.year}
            {selectedYacht?.id === item.yacht_id && <img src={check} alt=""/>}
          </button>)}
        </div>
        <div className="modal__inputItem">
          <p className="modal__label">{t('ownerShip')}:</p>
          <div className="modal__checks">
            <div className="modal__checkWrapper">
              <div onClick={() => {
                if (!isDisabled) setFieldValue('isPrivateOwn', false)
              }}
                   className={`modal__checkbox ${!isPrivateOwn && 'modal__checkboxSelected'}`}>
                {!isPrivateOwn && <div className="modal__circle"/>}
              </div>
              <p className={`modal__checkboxText ${isDisabled && 'modal__inputDisabled'}`}>{t('charter')}</p>
            </div>
            <div className="modal__checkWrapper">
              <div onClick={() => {
                if (!isDisabled) setFieldValue('isPrivateOwn', true)
              }}
                   className={`modal__checkbox ${isPrivateOwn && 'modal__checkboxSelected'}`}>
                {isPrivateOwn && <div className="modal__circle"/>}
              </div>
              <p className={`modal__checkboxText ${isDisabled && 'modal__inputDisabled'}`}>{t('private')}</p>
            </div>
          </div>
        </div>
        <div className="modal__inputItem">
          {!isPrivateOwn ? <>
            <p className="modal__label">{t('operator')}: <span className={'required'}>*</span></p>
            <div className="modal__inputWrapper w-100">
              <Field placeholder={t('notChosen')} value={operator} id={'operator'}
                     maxLength="60"
                     onChange={e => {
                       handleChange(e)
                       props.getCommonData(OPERATORS, e.target.value)
                       let operator = props.operators.find(o => o.name === e.target.value)
                       if (operator !== undefined) {
                         console.log(operator.name)
                         props.getCommonData(YACHTS, yacht, undefined, `&operator_id=${operator.id}`)
                       } else if (e.target.value.length === 0) {
                         props.getCommonData(YACHTS, yacht)
                       }
                     }} type="text"
                     className={`modal__input w-100 ${errors.operator && 'modal__inputError'} ${isDisabled && 'modal__inputDisabled'}`}
                     autoComplete={"off"} disabled={isDisabled}/>
              <div className="modal__list">
                <div className="modal__listItems">
                  {props.operators.map((o, index) => <button className="modal__listItem"
                                                             onClick={() => {
                                                               setFieldValue('operator', o.name)
                                                               let operator = props.operators.find(op => op.name === o.name)
                                                               props.getCommonData(YACHTS, yacht, undefined, `&operator_id=${operator.id}`)
                                                             }}
                                                             key={index}>
                    {o.name}
                  </button>)}
                </div>
              </div>
            </div>
          </> : <>
            <p className="modal__label">{t('yachtOwner')}:</p>
            <div className="modal__inputWrapper w-100">
              <Field placeholder={t('notChosen')} value={owner} id={'owner'}
                     onChange={e => {
                       if (e.target.value.length < 80) {
                         handleChange(e)
                       }
                     }} type="text" className={`modal__input w-100 ${isDisabled && 'modal__inputDisabled'}`}
                     disabled={isDisabled}/>
            </div>
          </>}
          <button className="modal__infoButton">
            <img src={infoIcon} alt=""/>
          </button>
        </div>
        {errors.operator && <div className={'modal__inputItem mt-0'}>
          <p className="modal__label"/>
          <p className="modal__errorText">{errors.operator}</p>
        </div>}
        <div className="modal__inputItem">
          <p className="modal__label">{t('yachtName')}:</p>
          <div className="modal__inputWrapper w-100">
            <Field placeholder={t('yachtName')} value={yacht} id={'yacht'}
                   autoComplete={'off'}
                   onChange={e => {
                     if (e.target.value.length < 80) {
                       handleChange(e)
                       let op = props.operators.find(o => o.name === operator)
                       if (op !== undefined) {
                         props.getCommonData(YACHTS, e.target.value, undefined, `&operator_id=${op.id}`)
                       } else {
                         props.getCommonData(YACHTS, e.target.value)
                       }
                       let yacht = props.yachts.find(y => y.name === e.target.value)
                       if (yacht !== undefined) {
                         setSelectedYacht({...yacht})
                         setFieldValue('model', yacht.yacht_model?.name)
                         props.getCommonData(YACHT_MODELS, yacht.yacht_model?.name)
                         setFieldValue('year', yacht.year)
                       } else if (selectedYacht && selectedYacht.name !== e.target.value) {
                         setSelectedYacht(null)
                       }
                     }
                   }} type="text"
                   className={`modal__input w-100 ${errors.yacht && 'modal__inputError'} ${isDisabled && 'modal__inputDisabled'}`}
                   disabled={isDisabled}/>
            <div className="modal__list">
              <div className="modal__listItems">
                {props.yachts.map((y, index) => <button className="modal__listItem"
                                                        onClick={() => {
                                                          setFieldValue('yacht', y.name)
                                                          setFieldValue('model', y.yacht_model?.name)
                                                          props.getCommonData(YACHT_MODELS, y.yacht_model?.name)
                                                          setFieldValue('year', y.year)
                                                          setSelectedYacht({...y})
                                                        }}
                                                        key={index}>
                  {y.name}
                </button>)}
              </div>
            </div>
          </div>
        </div>
        {errors.yacht && <div className={'modal__inputItem mt-0'}>
          <p className="modal__label"/>
          <p className="modal__errorText">{errors.yacht}</p>
        </div>}
        <div className="modal__inputItem">
          <p className="modal__label">{t('model')}: <span className={'required'}>*</span></p>
          <div className="modal__inputWrapper w-100">
            <Field placeholder={t('modelName')} value={model} id={'model'}
                   maxLength="60"
                   type="text"
                   className={`modal__input w-100 ${errors.model && 'modal__inputError'} ${isDisabled && 'modal__inputDisabled'}`}
                   onChange={e => {
                     handleChange(e)
                     props.getCommonData(YACHT_MODELS, e.target.value)
                     if (selectedYacht && selectedYacht.yacht_model?.name !== e.target.value) {
                       setSelectedYacht(null)
                     }
                   }} autoComplete="off" disabled={isDisabled}/>
            <div className="modal__list">
              <div className="modal__listItems">
                {props.yachtModels.filter(y => y.name.indexOf(model) !== -1).map((y, index) => <button
                  className="modal__listItem"
                  onClick={() => setFieldValue('model', y.name)} key={index}>
                  {y.name}
                </button>)}
              </div>
              <button onClick={openCreateModel} className="modal__list-add">
                <img src={plus} alt="" className={'modal__list-icon'}/>
                {t('addNewModel')}
              </button>
            </div>
          </div>
        </div>
        {errors.model && <div className={'modal__inputItem mt-0'}>
          <p className="modal__label"/>
          <p className="modal__errorText">{errors.model}</p>
        </div>}
        <div className="modal__inputItem">
          <p className="modal__label">{t('year')}:</p>
          <div className="modal__inputWrapper">
            <Field placeholder={t('chooseYear')} value={year} id={'year'}
                   onChange={e => {
                     handleChange(e)
                     if (selectedYacht && selectedYacht.year !== e.target.value) {
                       setSelectedYacht(null)
                     }
                   }} type="number"
                   className={`modal__input w-260 ${isDisabled && 'modal__inputDisabled'} ${errors.year && 'modal__inputError'}`}
                   disabled={isDisabled}/>
            <button className="modal__arrowIcon">
              <img src={arrowDown} alt=""/>
            </button>
            <div className="modal__list">
              <div className="modal__listItems">
                {[...Array(71)].map((_, index) => new Date().getFullYear() - index)
                  .map((y, index) => <button className="modal__listItem"
                                             onClick={() => {
                                               setFieldValue('year', y)
                                               if(selectedYacht) setSelectedYacht(null)
                                             }} key={index}>
                    {y}
                  </button>)}
              </div>
            </div>
          </div>
          <button data-tip data-for={'year'} className="modal__infoButton">
            <img src={infoIcon} alt=""/>
          </button>
          <ReactTooltip className={'tooltip'} backgroundColor={'#F7F8FB'} id={'year'} place="top" effect="solid">
            {t('chooseYearList')}
          </ReactTooltip>
        </div>
        {errors.year && <div className={'modal__inputItem mt-0'}>
          <p className="modal__label"/>
          <p className="modal__errorText">{errors.year}</p>
        </div>}
        {!isDisabled && <div className="modal__inputInner">
          <p className="modal__label"/>
          <CustomCheckBox isDark={isDark} isChecked={isAddFavorite} caption={t('addToFavYacht')}
                          color={'#A8A8A8'}
                          onClick={() => setFieldValue('isAddFavorite', !isAddFavorite)}
                          fontFamily={'Lato400'}/>
        </div>}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  yachtModels: state.dataReducer.yachtModels,
  operators: state.dataReducer.operators,
  favoriteYachts: state.profileReducer.favoriteYachts,
  profile: state.userReducer.profile,
  yachts: state.dataReducer.yachts
})

export default connect(mapStateToProps, {getCommonData, getFavoriteYachts})(React.memo(YachtInfoBlock));
